import { useCheckPermission } from '@webapp/hooks'
import { Permissions } from '@webapp/platform/iam'

export interface IUsePermissionsReturn {
  canManageCards: boolean
}

export const usePermissions = (): IUsePermissionsReturn => {
  const canManageCards = useCheckPermission(
    Permissions.SPENDING_CARD_MANAGE_CARD
  )

  return {
    canManageCards,
  }
}
